var exports = {
  "kL": "container__6Yj4tu",
  "Pf": "label__NgyUd5",
};

module.exports = exports;
